import { api } from '../api'
import { INaturalPerson, ITable, ServerResponse } from '../../models/models'
import { naturalPersonsInputs } from '../../constants/naturalPersonsPage'

export const naturalPersonsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getNaturalPersons: builder.query<ITable<INaturalPerson>, any>({
			query: (params) => ({
				url: 'natural-persons',
				params,
			}),
			providesTags: ['naturalPerson'],
			transformResponse: (response: ServerResponse<ITable<INaturalPerson>>) => response.data,
		}),
		getNaturalPersonById: builder.query<INaturalPerson, { id: string | number }>({
			query: ({ id }) => ({
				url: `natural-persons/${id}`,
			}),
			providesTags: ['naturalPerson'],
			transformResponse: (response: ServerResponse<INaturalPerson>) => ({
				...response.data,
				discountPerLiter: response.data?.discountPerLiter ? response.data?.discountPerLiter / 100 : 0,
			})
		}),
		editNaturalPerson: builder.mutation<INaturalPerson, { id: string | number; data: naturalPersonsInputs & { regionId: number } }>({
			query: (body) => ({
				url: `natural-persons/${body.id}`,
				method: 'PUT',
				body: body.data,
			}),
			invalidatesTags: ['naturalPerson'],
			transformResponse: (response: ServerResponse<INaturalPerson>) => response.data,
		}),
		changeNaturalPersonStatus: builder.mutation<INaturalPerson, { id: string | number }>({
			query: (body) => ({
				url: `natural-persons/${body.id}/status`,
				method: 'PUT',
			}),
			invalidatesTags: ['naturalPerson'],
			transformResponse: (response: ServerResponse<INaturalPerson>) => response.data,
		}),
		changeVisibleNaturalPersons: builder.mutation<ServerResponse<ITable<any>>, any>({
			query: (body) => ({
				url: 'natural-persons/view',
				method: 'PUT',
				body,
			}),
		}),
	}),
})

export const { useGetNaturalPersonsQuery, useGetNaturalPersonByIdQuery, useEditNaturalPersonMutation, useChangeNaturalPersonStatusMutation, useChangeVisibleNaturalPersonsMutation } =
	naturalPersonsApi
